<a
  class="tx-badge"
  *ngIf="txHash"
  [href]="explorerUrl"
  target="_blank"
  rel="noopener"
  matTooltip="Ver verificación en blockchain"
  matTooltipPosition="below"
>
  <span class="tx-hash"><span class="tx-hash-label">Tx</span> {{ shortHash }}</span>
  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path
      d="M23 12l-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82 1.89 3.2L12 21.04l3.4 1.46 1.89-3.2 3.61-.82-.34-3.69L23 12zm-12.91 4.72l-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35z"
    />
  </svg>
</a>
